<nx-accordion variant="light">
  <nx-expansion-panel class="accordion_remove_btm_space" [expanded]="true">
    <nx-expansion-panel-header>
      <nx-expansion-panel-title>Policy Movement
      </nx-expansion-panel-title>
    </nx-expansion-panel-header>

    <div>
      <app-external-scrollbar targetSyncScroll="1" [targetBaseWidth]="tableHolder1"></app-external-scrollbar>
      <div class="table-holder table_content_scroll only-this-horizon-scrollbar" #tableHolder1 syncScroll="1">
        <table nxTable zebra #table class="clickable_table" aria-label="policyMovementTableDesc">
          <thead>
            <tr nxTableRow>
              <th nxHeaderCell>
                <span nxCopytext="medium" class="nx-font-weight-semibold">No.</span>
              </th>
              <th nxHeaderCell>
                <span nxCopytext="medium" class="nx-font-weight-semibold">Endorsement Type</span>
              </th>
              <th nxHeaderCell>
                <span nxCopytext="medium" class="nx-font-weight-semibold">Effective <br> Date</span>
              </th>
              <th nxHeaderCell>
                <span nxCopytext="medium" class="nx-font-weight-semibold">Expiry <br> Date</span>
              </th>
              <th nxHeaderCell class="std-ta-right">
                <span nxCopytext="medium" class="nx-font-weight-semibold">Sum Insured <br> (RM)</span>
              </th>
              <th nxHeaderCell class="std-ta-right">
                <span nxCopytext="medium" class="nx-font-weight-semibold">Premium Due <br> (RM)</span>
              </th>
              <th nxHeaderCell>
                <span nxCopytext="medium" class="nx-font-weight-semibold text_no_wrap">Vehicle No.</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @if (policyMovemementTableData?.length) {
              <tr nxTableRow *ngFor="let item of paginatedResults; let i = index" (click)="openPopup3(item)">
                <td nxTableCell>
                  <span nxCopytext="medium">
                    {{ (curpage - 1) * perPage + i + 1 }}
                  </span>
                </td>
                <td nxTableCell>
                  <span nxCopytext="medium">
                    {{ item.endorsementDesc }}
                  </span>
                </td>
                <td nxTableCell>
                  <span nxCopytext="medium">
                    {{ item.effectiveDate }}
                  </span>
                </td>
                <td nxTableCell>
                  <span nxCopytext="medium">
                    {{ item.expiryDate }}
                  </span>
                </td>
                <td nxTableCell class="std-ta-right">
                  <span nxCopytext="medium">
                    {{ item.sumInsured }}
                  </span>
                </td>
                <td nxTableCell class="std-ta-right">
                  <span nxCopytext="medium">
                    {{ item.premiumDue }}
                  </span>
                </td>
                <td nxTableCell>
                  <span nxCopytext="medium">
                    {{ item.vehicleNo }}
                  </span>
                </td>
              </tr>
            }
            @else {
              <tr nxTableRow>
                <td nxTableCell colspan="7" class="std-ta-center">NO DATA</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <form [formGroup]="pageFilterForm" class="navigation">
      <div nxLayout="grid nopadding" class="nx-margin-top-2xs nx-margin-bottom-2m grid_remove_padding pagination_form">
        @if (showPagination && getResultLength() > 5) {
          <div nxRow>
            <div nxCol="12,12,6" class="nx-hidden-xs nx-hidden-s">
              <nx-natural-language-form size="small" class="pagination_form">
                <span nxCopytext="normal">Show</span>
                <nx-word>
                  <nx-dropdown formControlName="perPage" [panelGrow]="true" [panelMaxWidth]="500" [value]="perPage">
                    <nx-dropdown-item *ngFor="let item of itemsPerPageSelections" [value]="item"></nx-dropdown-item>
                  </nx-dropdown>
                </nx-word>
                <span nxCopytext="normal">results per page</span>
              </nx-natural-language-form>
            </div>
            <div class="nx-margin-xs margin-box nx-hidden-m nx-hidden-l nx-hidden-xl nx-hidden-2xl nx-hidden-3xl"></div>
            @if (getResultLength() > 5) {
              <div nxCol="12,12,6">
                <nx-pagination [count]="getResultLength()" [page]="curpage" [perPage]="perPage" type="advanced" class="pagination_position" (goPrev)="prevPage()" (goNext)="nextPage()" (goPage)="goToPage($event)"></nx-pagination>
              </div>
            }
          </div>
        }
      </div>
    </form>
  </nx-expansion-panel>
</nx-accordion>